module.exports = __webpack_public_path__ + "h5/img/PDF4.27ef789e.jpg";